// JavaScript files are compiled and minified during the build process to the assets/built folder. See available scripts in the package.json file.

// Import CSS
import "../css/index.css";

// Import JS
import menuOpen from "./menuOpen";
import infiniteScroll from "./infiniteScroll";


// Call the menu and infinite scroll functions
menuOpen();
infiniteScroll();

const clipboard = new ClipboardJS('.gh-top-server');
let clipboardTimer;

clipboard.on('success', function(e) {
    if (clipboardTimer) {
        clearInterval(clipboardTimer);
    }
    const elem = e.trigger.querySelector('.copy-tooltip');
    elem.classList.add('active');
    clipboardTimer = setTimeout(function() {
        elem.classList.remove('active');
        clipboardTimer = undefined;
    }, 3000);
});

